import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { AboutBannarResponse } from './models/aboutbannar-response.model';
import { AboutBannarModel } from './models/aboutbannar.model';


@Injectable({
  providedIn: 'root',
})
export class AboutBannarService extends BaseGQLService<AboutBannarResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: AboutBannarModel,
        clientName: 'AboutBannarService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryAboutContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }


}


